import { useCallback } from 'react'
import { authService } from '../services/authService'
import { queryClient } from '../lib/queryClient'

/**
 * Manages tenant-related actions: switching tenants.
 * Derived tenant state (hasTenant, tenants list) comes from the session user object.
 * Extracted from AuthContext for single-responsibility.
 *
 * @param {object} options
 * @param {function} options.checkAuth - re-fetches session after tenant switch
 */
export function useTenantState({ checkAuth }) {
  const switchTenant = useCallback(async (tenantId) => {
    const result = await authService.switchTenant(tenantId)
    // Clear ALL cached query data to prevent cross-tenant data leaks.
    // Query keys (e.g. ["initiatives"], ["team"]) are not tenant-scoped,
    // so stale data from the previous tenant would otherwise show briefly.
    queryClient.clear()
    await checkAuth()
    return result
  }, [checkAuth])

  return {
    switchTenant,
  }
}
